import _orderBy from 'lodash/orderBy';
import _isNil from 'lodash/isNil';
import _get from 'lodash/get';

export function dataTableItemsOrderByPagination<T>(
	items: T[],
	pagination: {
		sortBy?: string[]
		sortDesc?: boolean[]
	} | null,
): T[] {
	return _orderBy(
		items || [],
		(pagination?.sortBy || ['name']).map((prop: string): any => (v: any) => prop && !_isNil(_get(v, prop)) ? _get(v, prop) : ''),
		(pagination?.sortDesc || [false]).map((b: boolean): 'asc' | 'desc' => b ? 'desc' : 'asc'),
	) as T[];
}
